var map = {
	"./action_img.png": 300,
	"./background.png": 301,
	"./banner_shap.png": 302,
	"./cloud-computing.png": 303,
	"./cloud_01.png": 96,
	"./cloud_02.png": 97,
	"./cloud_03.png": 98,
	"./cloud_04.png": 99,
	"./cloud_05.png": 100,
	"./cloud_06.png": 101,
	"./crm_img1.jpg": 304,
	"./crm_img2.jpg": 305,
	"./crm_img3.jpg": 306,
	"./erp_dashboard.jpg": 102,
	"./erp_icon1.png": 307,
	"./erp_icon2.png": 308,
	"./erp_icon3.png": 309,
	"./erp_icon4.png": 310,
	"./erp_icon5.png": 311,
	"./erp_icon6.png": 312,
	"./growth.png": 313,
	"./img/01.png": 103,
	"./img/02.png": 104,
	"./img/03.png": 105,
	"./img/04.png": 106,
	"./img/05.png": 107,
	"./img/06.png": 108,
	"./img/07.png": 109,
	"./img/08.png": 110,
	"./img/09.png": 111,
	"./img/10.png": 112,
	"./img/11.png": 113,
	"./img/12.png": 114,
	"./img/13.png": 115,
	"./img/14.png": 116,
	"./img/15.png": 117,
	"./img/16.png": 118,
	"./img/17.png": 119,
	"./img/18.png": 120,
	"./img/19.png": 121,
	"./img/20.png": 122,
	"./quote.png": 314,
	"./rocket.png": 315,
	"./settings1.png": 316,
	"./shape.png": 317,
	"./testimonial_img.jpg": 318,
	"./testimonial_img2.jpg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;